import Node from './shared/Node';
import Block from '../dom/Block';

export default class ThenBlock extends Node {
	block: Block;
	children: Node[];
}